import React from "react";
import {
  UseFormRegisterReturn,
  Controller,
  Control,
  FieldValues,
} from "react-hook-form";
import Select, { CSSObjectWithLabel } from "react-select";
import {
  SelectionsLimitationType,
  FieldSettings,
  TextObject,
} from "@/shared/types";
import AlertCircleIcon from "@/shared/icons/AlertCircleIcon";

interface SelectInputProps {
  registerProps?: UseFormRegisterReturn;
  isError?: boolean;
  fieldSettings: FieldSettings;
  selectedOptions: string[];
  control: Control<FieldValues>;
  text: TextObject;
}
const SelectInput: React.FC<SelectInputProps> = ({
  registerProps,
  isError,
  fieldSettings,
  selectedOptions,
  control,
  text,
}) => {
  const isLimited =
    fieldSettings?.selections?.type === SelectionsLimitationType.Limited;
  const isMulti = fieldSettings?.isMultipleSelection;
  const selectionsCount = selectedOptions?.length || 0;

  const isMaxSelect =
    selectionsCount === fieldSettings?.selections?.selectionsCount;

  const options = fieldSettings?.options?.map((option) => ({
    value: option?.id,
    label: text[option?.label?.textId!],
  }));

  return (
    <div style={{ marginBottom: `${selectionsCount > 0 ? "30px" : "0px"}` }}>
      <Controller
        control={control}
        name={registerProps?.name!}
        render={({ field }) => (
          <Select
            {...field}
            styles={getSelectInputStyles(selectionsCount, isError!)}
            options={options}
            isMulti={isMulti}
            isClearable={!fieldSettings?.required}
            isOptionDisabled={() => (isMulti && isLimited && isMaxSelect)!}
            placeholder={text[fieldSettings?.placeholder?.textId!]}
            classNamePrefix="select"
            menuPortalTarget={
              typeof document === "undefined" ? undefined : document?.body
            }
          />
        )}
      />
      {isError && <AlertCircleIcon />}
    </div>
  );
};

export default SelectInput;

/* Styles */
const getSelectInputStyles = (selectionsCount: number, isError: boolean) => ({
  control: (baseStyles: CSSObjectWithLabel) => ({
    ...baseStyles,
    border: ` ${
      isError ? "1px solid #FDA29B !important" : "1px solid #D0D5DD"
    }  `,
    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
    borderRadius: "6px",
    "&:hover": {
      border: ` ${isError ? "1px solid #FDA29B" : "1px solid #D0D5DD"}  `,
    },
  }),
  multiValue: (baseStyles: CSSObjectWithLabel) => ({
    ...baseStyles,
    padding: "2px 6px 2px 8px",
    background: "#F2F4F7",
    borderRadius: "16px",
  }),
  valueContainer: (baseStyles: CSSObjectWithLabel) => ({
    ...baseStyles,
    top: `${selectionsCount > 0 ? "45px" : "0px"}`,
    padding: `${selectionsCount > 0 ? "0px" : "2px 8px"}`,
  }),
  multiValueRemove: () => ({
    color: "#667085",
    cursor: "pointer",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  indicatorsContainer: (baseStyles: CSSObjectWithLabel) => ({
    ...baseStyles,
    cursor: "pointer",
  }),
  menuPortal: (baseStyles: CSSObjectWithLabel) => ({
    ...baseStyles,
    zIndex: 9999,
  }),
});
